import type {
  UpdateBrokerProductDto,
  UpdateBrokerProductsResult,
} from '@/services/brokers/types';

/**
 * Mensagem de erro quando a Api salvou só parte dos produtos, ou `null`
 * quando tudo foi salvo.
 *
 * A Api responde 200 com a lista `error` quando um produto não gravou.
 * Tratar isso como sucesso era o "vinculou, mas sumiu no refresh".
 */
export function unsavedProductsMessage(
  products: UpdateBrokerProductDto[],
  result: UpdateBrokerProductsResult | undefined
): string | null {
  const failed = result?.error ?? [];
  if (failed.length === 0) return null;

  const names = failed.map(item => productLabel(products, item.id));
  return `Não foi possível salvar: ${names.join(', ')}. Tente novamente.`;
}

/** Nome do produto do payload pelo `id` que a Api devolve na lista de erro. */
function productLabel(products: UpdateBrokerProductDto[], id: string) {
  const product = products.find(
    item => (item.id ?? item.productCode) === id || item.productCode === id
  );
  return product?.productName ?? product?.productCode ?? id;
}
